import { useContext, useRef } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import LocaleContext from '../contexts/locale';
import { isObject } from 'lodash';

export const useCustomerByUuid = (uuid) => {
	const { uuidMap } = useCustomers();

	if (uuid in uuidMap) {
		return uuidMap[uuid];
	}

	return null;
};

export const useCustomersByUuid = (uuids) => {
	const { uuidMap } = useCustomers();

	return uuids.map((uuid) => uuidMap[uuid]).filter((customer) => isObject(customer));
};

export const useCustomers = () => {
	const {
		allMarkdownRemark: { edges: customers },
	} = useStaticQuery(query);

	const allRef = useRef([]);
	const uuidMapRef = useRef({});
	const localeMapRef = useRef({});

	const { currentLocale: locale } = useContext(LocaleContext);

	const mapItem = ({ node: { fields, frontmatter: data } }) => ({
		...data,
		...fields,
	});

	if (allRef.current.length === 0) {
		for (let customer of customers) {
			const item = mapItem(customer);
			const { uuid, locale } = item;

			localeMapRef.current[locale] = localeMapRef.current[locale] || [];
			localeMapRef.current[locale].push(item);
			uuidMapRef.current[uuid] = item;
			allRef.current.push(item);
		}
	}

	return {
		items: localeMapRef.current[locale],
		uuidMap: uuidMapRef.current,
	};
};

const query = graphql`
	query useCustomers {
		allMarkdownRemark(
			filter: { frontmatter: { type: { eq: "customer" } } }
			sort: { frontmatter: { name: ASC } }
		) {
			edges {
				node {
					frontmatter {
						uuid
						name
						url
						image {
							file {
								childImageSharp {
									gatsbyImageData(layout: CONSTRAINED, width: 200)
								}
							}
							title
							alt
						}
					}
					fields {
						locale
					}
				}
			}
		}
	}
`;
